<template>
  <div id="app">
    <main :class="[{'mobile': !isDesktop}]">
        <template v-if="isDesktop">
          <div class="wrap">
            <b-header></b-header>
            <b-content></b-content>
          </div>
          <b-footer></b-footer>
        </template>
        <template v-else>
          <div class="wrap">
            <b-m-header></b-m-header>
            <b-m-content></b-m-content>
            <b-m-footer></b-m-footer>
           </div>
        </template>
    </main>
  </div>
</template>

<script>
import content from "./views/home";
import header from "./views/includes/header";
import footer from "./views/includes/footer";
import mContent from "./views/mhome";
import mHeader from "./views/includes/mheader";
import mFooter from "./views/includes/mfooter";
import MobileDetect from "mobile-detect";

/**
 * Singleton data object for application
 *
 * @type {Function}
 * @returns {Object}
 */
const getProvideData = () => {
  const host = "https://kinoart.ru";

  const data = {
    $rootProject: {
      title: "Искусство кино - молодой сайт старейшего в Европе журнала о кино: рецензии, аналитика, карточки, лекции",
      logo: "dist/assets/img/logo/kino.svg",
      logoMobile: "dist/assets/img/logo/kino_mobile.svg",
      link: `${host}`
    },
    $projectUrl: `${host}/venice2019/`,
    $projectTitle: "76-й Венецианский кинофестиваль",
    $3dParty: {
      kinotavr2020: {
        title: "Кинотавр-2020",
        link: "https://kinotavr.ru/",
      },
      berlin2020: {
        title: "Берлин-2020",
        link: "https://kinoart.ru/berlin2020/",
      },
      venice2019: {
        title: "76-й Венецианский кинофестиваль",
        link: "https://www.labiennale.org/en/cinema/2019/",
        logo: "dist/assets/img/logo/logo-venice.svg"
      },
      kinotavr2019: {
        title: "Кинотавр-2019",
        link: "https://kinoart.ru/kinotavr2019/",
        logo: "dist/assets/img/logo/logo_kinotavr.svg"
      },
      cannes: {
        title: "Канны-2019",
        link: "https://kinoart.ru/cannes2019/",
        logo: "dist/assets/img/logo/Festival_de_Cannes_logo.svg"
      },
      roskino: {
        title: "Роскино",
        link: "https://roskino.org/",
        logo: "dist/assets/img/logo/roskino.png"
      },
      berlin2019: {
        title: "Берлин-2019",
        link: `https://kinoart.ru/berlin2019`,
      }
    },
    $helperImagePath(path, category = "movies") {
      if (path.match(/^(http|https)/)) {
        return path;
      }

      return `dist/assets/img/${category}/${path}`;
    }
  };

  return data;
};

export default {
  provide: { ...getProvideData() },
  components: {
    "b-content": content,
    "b-header": header,
    "b-footer": footer,
    "b-m-content": mContent,
    "b-m-header": mHeader,
    "b-m-footer": mFooter
  },
  name: "app",
  data() {
    return {
      windowWidth: true
    };
  },
  mounted() {
    this.$nextTick(function() {
      let style = ["font: 14px Pragmatica;", "color: #222222;"].join("");


      window.addEventListener("resize", this.getWindowWidth);

      this.getWindowWidth();
    });
  },
  computed: {
    isDesktop() {
      return this.windowWidth > 639 && !this.isMobile();
    }
  },
  methods: {
    getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth;
    },
    isMobile() {
      return !!new MobileDetect(window.navigator.userAgent).mobile();
    }
  }
};
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/App.vue